module.exports = __webpack_public_path__ + "../resources/images/illustration_error-b2c550466a52b3b75917b5eb41397ce5.svg";